// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2c-l7","buttons":"styles_buttons__34bQr"};